import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { SectionLabel } from "@/components/common/SectionLabel";
import { MatchCard } from "@/components/matchday/MatchCard";

const previewMatch = {
  homeTeam: "Team name goes here",
  awayTeam: "Team name goes here",
  date: "Date goes here",
  kickOff: "KO time goes here",
  competition: "Competition goes here",
  venue: "Venue goes here",
  status: "upcoming",
};

export const MatchdayPreview = () => (
  <section data-testid="matchday-preview-section" className="bg-surface-dark py-24">
    <div className="mx-auto max-w-7xl px-6 lg:px-12">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <Reveal>
          <SectionLabel index="02" title="Matchday" />
          <h2 className="mt-3 font-heading text-4xl uppercase text-white sm:text-5xl">Upcoming Coverage</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Link to="/matchday" data-testid="matchday-preview-view-all" className="inline-flex items-center gap-2 font-subheading text-sm font-semibold uppercase tracking-wide text-brand-purple hover:text-white transition-colors">
            View Full Fixture List <ArrowUpRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="mt-10 max-w-xl">
        <MatchCard match={previewMatch} />
      </Reveal>
    </div>
  </section>
);
